/* @flow */
import cx from 'classnames';
import * as React from 'react';

import Glyph from 'components/Glyph.jsx';
import Heading from 'components/Heading.jsx';
import Image from 'components/Image.jsx';
import MediaObject from 'components/MediaObject.jsx';

import './styles/TitleHeader.scss';

import type { GlyphName } from '@remind/r101-glyphs';
import type { Props as HeadingProps } from 'components/Heading.jsx'; // eslint-disable-line no-unused-vars

// prettier-ignore
export type Props = {
  /** Button or loading indicator */
  action?: any,
  actionPlacement?: ?'right' | 'right-center' | 'bottom',
  children?: React.Node,
  className?: string,
  color?: 'white',
  flush?: boolean,
  glyph?: GlyphName,
  glyphColor?: 'inherit' | 'lava' | 'flame' | 'sunrise' | 'shamrock' | 'jungle' | 'brand' | 'violet' | 'thunder' | 'midnight' | 'eclipse' | 'koala' | 'pitch' | 'white',
  image?: ?string,
  /** Prefer imageSize—use only to restrict image `height` */
  imageClassName?: string,
  imageSize?: 'large' | 'medium' | 'small' | 'xsmall' | 'xxsmall' | 'xxxsmall',
  /** If used in a non-self-centering null state */
  nullState?: boolean,
  size?: 'large' | 'medium' | 'small',
  subtext?: any,
  textAlign?: 'left' | 'center' | 'right',
  // XXX we allow subtext and images without primary title
  title?: any,
  /* :: ...$Exact<HeadingProps>, */
};

export default class TitleHeader extends React.Component<Props> {
  static defaultProps = {
    glyphColor: 'brand',
    size: 'medium',
    textAlign: 'center',
  };

  render() {
    const {
      action: propsAction,
      actionPlacement,
      children,
      className,
      color,
      flush,
      glyph,
      glyphColor,
      level, // eslint-disable-line react/prop-types
      image,
      imageClassName,
      imageSize,
      nullState,
      size,
      subtext,
      title,
    } = this.props;
    let { textAlign } = this.props;

    const actionOnRight = actionPlacement === 'right' || actionPlacement === 'right-center';

    let levelStyle = null;

    if (actionOnRight) {
      textAlign = 'left';
    }

    if (size === 'medium') {
      levelStyle = '2';
    } else if (size === 'large') {
      levelStyle = '1';
    } else if (size === 'small') {
      levelStyle = '4';
    }

    const contents = (
      <React.Fragment>
        {glyph && <Glyph color={glyphColor} name={glyph} solo className="TitleHeader-glyph" />}
        {image && (
          <Image
            src={image}
            className={cx(
              'TitleHeader-img',
              imageClassName,
              imageSize && `TitleHeader-img--${imageSize}`
            )}
          />
        )}
        <Heading level={level || '1'} levelStyle={levelStyle} className="TitleHeader-title">
          {title}
        </Heading>
        {subtext && <div className="TitleHeader-subtext">{subtext}</div>}
      </React.Fragment>
    );

    const content = children ? <div className="TitleHeader-content">{children}</div> : null;

    const action = <div className="TitleHeader-action">{propsAction}</div>;

    const body = actionOnRight ? (
      <React.Fragment>
        <MediaObject center={actionPlacement === 'right-center'} figure="right">
          <div>{contents}</div>
          {propsAction ? action : null}
        </MediaObject>
        {content}
      </React.Fragment>
    ) : (
      <React.Fragment>
        {contents}
        {content}
        {propsAction ? action : null}
      </React.Fragment>
    );

    return (
      <div
        className={cx(
          'TitleHeader',
          actionPlacement && `TitleHeader--actionPlacement--${actionPlacement}`,
          color && `TitleHeader--${color}`,
          flush && 'TitleHeader--flush',
          nullState && 'TitleHeader--null',
          size && `TitleHeader--${size}`,
          textAlign && `TitleHeader--${textAlign}`,
          className
        )}>
        {body}
      </div>
    );
  }
}
